import {getMessageCount} from "../../api/message";

const state = {
  weather_info: {},
  ac_info: {},
  message_cnt: 0
}

const mutations = {
  SET_WEATHER_INFO: (state, weather_info) => {
    state.weather_info = weather_info
  },
  SET_AC_INFO: (state, ac_info) => {
    state.ac_info = ac_info
  },
  SET_MESSAGE_CNT: (state, message_cnt) => {
    state.message_cnt = message_cnt
  }
}

const actions = {
  async setWeatherInfo({ commit }, weatherInfo) {
    commit('SET_WEATHER_INFO', weatherInfo)
  },
  async setAcInfo({ commit }, acInfo) {
    commit('SET_AC_INFO', acInfo)
  },
  async setMessageCnt({ commit }) {
    getMessageCount().then((res) => {
      if (res.data.data && res.data.data.count > 0) {
        commit('SET_MESSAGE_CNT', res.data.data.count)
      } else {
        commit('SET_MESSAGE_CNT', '')
      }
    }).catch((e) => {
      this.loading = false
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notice.js